<template>
  <div class="card-body maxheight">
    <div class="row justify-content-center">
      <div class="col-8">
        <div class="row lead">
          <span v-if="usesQ4">{{
              buildTitle(data.title, user)
          }}</span><span v-else>
            {{ data.title }}
          </span>
        </div>
        <div class="row my-4">
          <form style="width:100%">
            <textarea type="text" :v-model="uniqueInput" :value="uniqueInput" :style="{ width: 100 + '%' }"
              @input="event => uniqueInput = event.target.value" />

          </form>
        </div>
      </div>

    </div>
  </div>
  <div class="card-footer">
    <div class="row justify-content-center">
      <div @click="previous()" class="btn btn-small  nsc-cta mx-4 my-2">
      Previous
      </div>
      <div @click="validateAnswer" class="btn btn-small  nsc-cta blue mx-4 my-2">
        Next
      </div>
    </div>
  </div>

</template>
<script>
export default {
  name: "ShortAnswer",
  props: ["data", "nextQ", "user", "answers", "prevQ"],
  emits: ["nextQuestion", "uniqueAnswer", "previousQuestion"],
  data() {
    return {
      usesQ4: this.data.usesQ4 ? true : false,
      uniqueInput: this.answers ? this.answers : "",
      previousQ: this.prevQ
    }
  },
  methods: {
    buildTitle(arr, user) {
      return `${arr[0]} ${user.company} ${user.subsector} ${arr[1]}`;
    },
    validateAnswer() {

      if(this.uniqueInput.trim().length > 1) {
        this.$emit('uniqueAnswer', this.data.ID, this.uniqueInput)
        this.$emit('nextQuestion', this.nextQ, true)
      } else {
        this.$emit('nextQuestion', this.nextQ, false)
      }
      
    },
    previous(){
      if(this.data.ID == 15) {
        this.previousQ == 14
      } 
      if(this.uniqueInput.trim().length > 1){
        this.$emit('uniqueAnswer', this.data.ID, this.uniqueInput)
        this.$emit('previousQuestion', this.previousQ, true)
      } else {
        this.$emit('uniqueAnswer', this.data.ID, this.uniqueInput)
        this.$emit('previousQuestion', this.previousQ, false)
      }

    }
  }
}
</script>